import React from 'react';
import { getFormattedDateTime } from './value-formatters/date-formatter.mjs';
import { pastTenseStatus, transferDetailsMicroStatus, transferErrorMicrostatus, transferStepStatus } from '@/utils/constants';
import { TransferMicroStatusWorkflow, TransferMicrostatus, keyType } from '../types';
import { getFormattedStatus, showRemainingTime } from '../utils';

function TransferWorkflowStatus({
  transferStatusWorkflow,
  version,
  stepStatus
}: {
  transferStatusWorkflow: Array<TransferMicroStatusWorkflow>;
  version: number;
  stepStatus?: string
}) {

  const getStatusText = (step: any) => {
    const statuses = version === 1 ? (pastTenseStatus[step.status] || transferDetailsMicroStatus[step.status as keyType<typeof transferDetailsMicroStatus>]) : transferDetailsMicroStatus[step.status as keyType<typeof transferDetailsMicroStatus>];
    let emailText = '';
    if (step.status === TransferMicrostatus.resent_email) {
      emailText = `(${step.metaData?.toEmail || step.metaData?.email})`
    } else if (step.metaData?.email && ((step.status === TransferMicrostatus.dealer_selected) && (step.status === TransferMicrostatus.customer_selected))) {
      emailText = `(${step.metaData?.email})`
    } else if (step.status === TransferMicrostatus.email_not_found) {
        if(step?.metaData?.email) {
            emailText = `(marked by ${step?.metaData?.email}) on `
        } else if(step?.metaData?.actionPerformedBy === 'System') {
            emailText = `(schedule timeout) on `
        }
    }
    const statusText = stepStatus === transferStepStatus.success ? getFormattedStatus(statuses, step) : getFormattedStatus(transferDetailsMicroStatus[step.status as keyType<typeof transferDetailsMicroStatus>], step)

    return (
      <>
        {`${statusText} ${emailText}`}
      </>
    )
  }

  const getFormattedTime = (step: any) => {
    if (step && step?.metaData && step?.metaData?.schedulerTimeout && step?.metaData?.schedulerId && !step?.metaData?.stopped_at && !step?.metaData?.executed_at) {
      const formattedTime = showRemainingTime(step);
      return (
        <p className="transfer-status-info__time">
          {formattedTime}
        </p>
      )
    }

    return (
      step.status !== TransferMicrostatus.email_available && (
        <p className="transfer-status-info__time">
          As on {getFormattedDateTime(step.metaData && step.metaData?.timestamp ? step.metaData.timestamp : step.createdAt)}
        </p>
      )
    )
  }

  return (
    <ul className="transfer-details__status-list">
      {transferStatusWorkflow.map((step) => (
        <li>
          <div className="step-indicator">
            <div className="step-indicator__dot">
              <div className={`step-indicator__dot-inner ${transferErrorMicrostatus.includes(step.status) || step?.metaData?.status === transferStepStatus.failed ? "step-indicator__dot-error" : ""}`}>
                {
                  transferErrorMicrostatus.includes(step.status) || step?.metaData?.status === transferStepStatus.failed ? <img src="/images/ui/cross.svg" alt="" /> : <img src="/images/ui/check.svg" alt="" />
                }
              </div>
            </div>
            <div className="step-indicator__connector"></div>
          </div>
          <div className="transfer-status-info">
            <h3 className="transfer-status-info__title">
              {getStatusText(step)}
            </h3>
            {getFormattedTime(step)}
          </div>
        </li>
      ))}
    </ul>
  );
}

export default TransferWorkflowStatus;
